export const DEFAULT_SIDEBAR_SIZE = 68;
